import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const DiscordIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path d="M19.27 5.33A16.6 16.6 0 0 0 15.23 4c-.18.32-.38.75-.52 1.09a15.4 15.4 0 0 0-4.42 0A9.9 9.9 0 0 0 9.76 4a16.6 16.6 0 0 0-4.05 1.33C3.13 9.18 2.43 12.93 2.78 16.63a16.7 16.7 0 0 0 5.04 2.55c.4-.55.77-1.14 1.08-1.76-.6-.22-1.16-.5-1.7-.82.14-.1.28-.21.42-.32a11.9 11.9 0 0 0 10.24 0c.14.11.28.22.42.32-.54.32-1.11.6-1.7.82.31.62.68 1.21 1.08 1.76a16.7 16.7 0 0 0 5.04-2.55c.42-4.29-.69-8-2.43-11.3ZM9.35 14.38c-.99 0-1.8-.9-1.8-2.01s.79-2.02 1.8-2.02 1.82.91 1.8 2.02c0 1.11-.8 2.01-1.8 2.01Zm5.31 0c-.99 0-1.8-.9-1.8-2.01s.79-2.02 1.8-2.02 1.82.91 1.8 2.02c0 1.11-.79 2.01-1.8 2.01Z" />
    </SvgIcon>
)

export default DiscordIcon
